import getBackgroundBaseUrl from './getBackgroundBaseUrl.js';

/**
 * Converts the Polotno page background image URL to the absolute URL.
 * Sometimes background can be defined as relative URL.
 * @param {string} backgroundImage Absolute or relative URL
 * @param {object} template Parabo template data
 * @param {boolean} useServerAssets
 * @returns {string} Absolute URL
 */
const convertBackgroundToAbsoluteUrl = (backgroundImage, template, useServerAssets) => {
  const base = getBackgroundBaseUrl(template, useServerAssets);
  return new URL(backgroundImage, base).toString();
};

export default convertBackgroundToAbsoluteUrl;
